export default __webpack_public_path__ + "assets/images/2b358bc69581784b6b3a21c41339fe83.png";